"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseCalculatedFieldValueGetter = void 0;
const safe_field_value_1 = require("../safe-field-value");
const get_field_value_1 = require("../helpers/get-field-value");
class BaseCalculatedFieldValueGetter extends safe_field_value_1.BaseFieldValueGetter {
    constructor() {
        super(...arguments);
        this.getFieldValue = (field, record) => {
            var _a, _b;
            const fieldValue = (0, get_field_value_1.getValueFromRecordBySlug)(record, field);
            if (fieldValue === undefined)
                return this.getEmptyValue();
            const targetField = (_b = (_a = field === null || field === void 0 ? void 0 : field.params) === null || _a === void 0 ? void 0 : _a.target_field_structure) !== null && _b !== void 0 ? _b : null;
            if (targetField === null)
                return this.getEmptyValue();
            if (!this.isValidFieldValue(fieldValue))
                return this.getEmptyValue();
            return fieldValue;
        };
    }
}
exports.BaseCalculatedFieldValueGetter = BaseCalculatedFieldValueGetter;
